<template>
  <v-card flat tile>
    <v-card-title style="height: 64px" class="pa-0 my-0">
      <v-btn @click="goBack()" icon>
        <v-icon v-text="$vuetify.icons.arrowLeft"></v-icon>
      </v-btn>
      <span class="title px-2">{{item.plate}}</span>
      <span :class="item.isExpire ? 'grey--text':'primary--text'">
        {{item.isExpire ? '失效':'有效'}}
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout>
          <v-flex xs3>
            访客手机
          </v-flex>
          <v-flex shrink class="text-xs-left">
            {{item.phone}}
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs3>
            开始时间
          </v-flex>
          <v-flex shrink class="text-xs-left">
            {{$L.time.stringify(item.startDatetime)}}
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs3>
            结束时间
          </v-flex>
          <v-flex shrink class="text-xs-left">
            {{$L.time.stringify(item.endDatetime)}}
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'reservationDetails',
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
